import * as Web3 from 'web3';
var promisify = require('tiny-promisify');
import * as Web3BetaUtils from 'web3-utils';

export class Web3Utils {
    public static soliditySHA3(...payload: any[]): string {
        // TODO type check function name to ensure it exists!
        return Web3BetaUtils.soliditySha3(...payload);
    }

    private web3: Web3;

    constructor(web3: Web3) {
        this.web3 = web3;
    }

    public async getNetworkIdAsync(): Promise<number> {
        return promisify(this.web3.version.getNetwork)();
    }

    public async getAvailableAddressesAsync(): Promise<string[]> {
        return promisify(this.web3.eth.getAccounts)();
    }

    public async doesContractExistAtAddressAsync(address: string): Promise<boolean> {
        const code = await promisify(this.web3.eth.getCode)(address);

        // Regex matches 0x0, 0x00, 0x in order to accommodate poorly implemented clients
        const codeIsEmpty = /^0x0{0,40}$/i.test(code);
        return !codeIsEmpty;
    }
}
